document.documentElement.className =
  document.documentElement.className.replace(/\bno-js\b/g, "") + "js";

if (window.location.hash) {
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 2);
}

jQuery(document).ready(function ($) {
  var countdownTimer = (function () {
    if (!$(".countdown-block").length) {
      return;
    }

    // Get the countdown date and time from the data attributes
    var countdownDate = $(".countdown-timer").data("countdown-date");
    var countdownTime = $(".countdown-timer").data("countdown-time");

    // Split the date and time strings into arrays
    var dateArray = countdownDate.split("-");
    var timeArray = countdownTime.split(":");

    // Extract components
    var year = parseInt(dateArray[2]); // Assuming the year is in the format 'YYYY'
    var month = parseInt(dateArray[0]) - 1; // Months are zero-based in JavaScript
    var day = parseInt(dateArray[1]);
    var hours = parseInt(timeArray[0]);
    var minutes = parseInt(timeArray[1]);

    // Convert the combined countdown date and time to a JavaScript Date object
    var countdownDateTimeObject = new Date(
      year,
      month,
      day,
      hours,
      minutes,
      0,
      0
    );

    // Update the countdown every second
    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countdownDateTimeObject - now;

      // Calculate days, hours, minutes, and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the countdown using jQuery
      $(".countdown-timer").html(
        "<span class='countdown-item'>" +
          days +
          "<span>days</span></span>" +
          "<span class='countdown-item'>" +
          hours +
          "<span>hours</span></span>" +
          "<span class='countdown-item'>" +
          minutes +
          "<span>minutes</span></span>" +
          "<span class='countdown-item'>" +
          seconds +
          "<span>seconds</span></span>"
      );

      // If the countdown is over, display a message
      if (distance < 0) {
        clearInterval(x);
        $(".countdown-timer").html("EXPIRED");
      }
    }, 1000); // Update every second
  })();

  /*let url = "https://www.hellonoemie.com/pages/thank-you-design-team?email=nick.marsh%40powerdigitalmarketinginc.com";
let updatedUrl = url.replace(/%40/g, "@");*/

  var allRingSizesInput = (function () {
    if (!$(".all-sizes").length) {
      return;
    }

    function toggleButtonState() {
      var selectedSize = $("#all-sizes-input").val();
      var addToCartButton = $(".atc-btn");

      // Check if the input is blank or not a number
      if (selectedSize === "" || isNaN(selectedSize)) {
        $(addToCartButton).prop("disabled", true);
        $(".size-error").show();
      } else {
        $(addToCartButton).prop("disabled", false);
        $(".size-error").hide();
      }
    }

    // Initially disable the button if the input is blank
    toggleButtonState();

    // Add an input event listener to check and toggle the button state
    $("#all-sizes-input").on("input", toggleButtonState);

    $(document).on("click", ".atc-btn", function (e) {
      var input = $(this).closest("form").find("#all-sizes-input");
      var allSizes = $(this).closest("form").find(".all-sizes");
      var selectedSize = $(input).val();

      $(allSizes).attr("data-size", selectedSize);
    });
  })();

  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

  var urlParams = (function (strParam) {
    var objParams = {};

    function init() {
      objParams = {};
      var arrURLParams = window.location.search.replace("?", "").split("&");
      arrURLParams.map(function (val) {
        var arrPair = val.split("=");
        objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
      });
    }
    init();
    return {
      get: function (strParam) {
        return objParams[strParam];
      },
      pull: init,
    };
  })();

  var LazyLoading = (function () {
    var instance = new LazyLoad();

    function lazyBGImages() {
      var $bgImages = $("[data-bg]:not(.lazy)");
      if ($bgImages.length) {
        $bgImages.each(function () {
          $(this).addClass("lazy");
        });
      }
    }

    function update() {
      lazyBGImages();
      instance.update();
    }

    lazyBGImages();

    return {
      update: update,
    };
  })();

  var SmoothScroll = (function () {
    var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

    $('a[href="#"]').click(function (e) {
      e.preventDefault();
      return;
    });

    function goTo(target) {
      if (target === "" || !$(target).length) {
        return;
      }
      var scrollPos =
        typeof target === "number" ? target : $(target).offset().top;

      if (window.innerWidth >= 720) {
        scrollPos -= $("header").outerHeight();
      } else {
        scrollPos -= $("header").outerHeight() * 2;
      }

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: scrollPos - 32,
          },
          1200,
          "swing",
          function () {
            if (typeof target === "string") {
              if (window.location.hash) {
                // window.location.hash = target;
              }
            }
          }
        );
    }

    if (window.location.hash) {
      setTimeout(function () {
        goTo(window.location.hash);
      }, 500);
    }

    if ($anchorLinks.length) {
      $anchorLinks.on("click", function (e) {
        if (!$("#" + this.hash.replace("#", "")).length) {
          return;
        }
        e.preventDefault();
        goTo(this.hash);
      });
    }

    return { to: goTo };
  })();

  //Global function to toggle simple accordions
  var Accordions = (function () {
    var $accordions = $(".accordion");
    if (!$accordions.length) {
      return;
    }

    $accordions.each(function () {
      if ($(this).hasClass("active")) {
        $(this).find(".accordion__content").show();
      }
    });

    $accordions.find(".accordion__trigger").click(function (e) {
      var $this = $(this);
      var $accordion = $this.parent();
      var $content = $accordion.find(".accordion__content");
      var $siblings = $accordion.siblings();

      if ($accordion.hasClass("active")) {
        $accordion.removeClass("active");
        $content.slideUp("fast");
      } else {
        $accordion.addClass("active");
        $siblings
          .removeClass("active")
          .find(".accordion__content")
          .slideUp("fast");
        $content.slideDown("fast");
      }
    });
  })();

  var subscriptionTiers = (function () {
    var $section = $(".subscription-tiers");
    if (!$section.length) {
      return;
    }
    $section.each(function () {
      var $wrapper = $(this);
      var $triggers = $wrapper.find(".subscription-tiers__btns button");
      var $content = $wrapper.find(".sub-column__price");

      $triggers.click(function (e) {
        var ID = $(this).attr("data-sub");
        const anchors = document.querySelectorAll(".selector-subs");

        $triggers.removeClass("active").filter(this).addClass("active");
        $content.addClass("hidden");
        $content.filter('[data-sub="' + ID + '"]').removeClass("hidden");

        anchors.forEach((anchor) => {
          const $anchorParent = anchor.closest(".sub-column");
          const excerptData = JSON.parse(
            $anchorParent.querySelector(".excerpt_data").innerText
          );
          const $description = $anchorParent.querySelector(
            ".description-product"
          );
          if (anchor) {
            let newHref = anchor.getAttribute("data-month-handle");
            $description.innerHTML = excerptData.find(
              (data) => data.type == "normal"
            ).excerpt;

            if (ID === "annual") {
              newHref = anchor.getAttribute("data-annual-handle");
              $description.innerHTML = excerptData.find(
                (data) => data.type == "normal"
              ).excerpt;
            }

            if (ID === "affiliate") {
              newHref = anchor.getAttribute("data-affiliate-handle");
              $description.innerHTML = excerptData.find(
                (data) => data.type == "affiliate"
              ).excerpt;
            }

            anchor.href = newHref;
          }
        });
      });
    });
  })();

  //
  var InputMasks = (function () {
    var $masks = $("[data-mask]");
    if (!$masks.length) {
      return;
    }

    $("[data-mask]").keyup(function (e) {
      switch (this.dataset.mask) {
        case "phone":
          var x = this.value
            .replace(/\D/g, "")
            .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          this.value = !x[2]
            ? x[1]
            : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
          break;
        case "ssn": {
          var x = this.value
            .replace(/\D/g, "")
            .match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
          this.value = !x[2] ? x[1] : x[1] + "-" + x[2] + "-" + x[3];
        }
      }
    });
  })();

  //Plugin used for form validation
  var parselyOptions = {
    classHandler: function (parsleyField) {
      var $element = parsleyField.$element;
      if ($element.parent().hasClass("select-menu")) {
        return $element.parent();
      }
      return $element;
    },
    errorsContainer: function (parsleyField) {
      var $element = parsleyField.$element;
      var $fieldContainer = $element.closest(".form-field");
      if ($fieldContainer) {
        return $fieldContainer;
      }
    },
  };

  //Global function to set form state classes
  var formStates = (function () {
    $formInputs = $("main form :input");
    if (!$formInputs.length) {
      return;
    }

    $formSelectMenus = $(
      ".select-menu select, .ginput_container_select select"
    );

    function isGFormInput($el) {
      return $el.hasClass("ginput_container") ? $el.parent() : $el;
    }

    function setFilled($input) {
      var $parent = isGFormInput($input.parent());

      $parent.addClass("filled");
    }

    function removeFilled($input) {
      var $parent = isGFormInput($input.parent());

      $parent.removeClass("filled");
    }

    function setFocused() {
      var $parent = isGFormInput($(this).parent());

      $parent.addClass("focused");
    }

    function removeFocused() {
      var $parent = isGFormInput($(this).parent());

      $parent.removeClass("focused");
    }

    function checkInput(e) {
      if (
        this.type == "button" ||
        this.type == "range" ||
        this.type == "submit" ||
        this.type == "reset"
      ) {
        return;
      }

      var $this = $(this);
      var $parent = $this.parent();
      var is_selectMenu =
        $parent.hasClass("select-menu") ||
        $parent.hasClass("ginput_container_select");

      var $input = is_selectMenu ? $parent : $this;

      switch (this.type) {
        case "select-one":
        case "select-multiple":
          if (this.value !== "") {
            setFilled($input);
          } else {
            removeFilled($input);
          }
          break;
        default:
          if (this.value) {
            setFilled($input);
          } else {
            removeFilled($input);
          }
          break;
      }
    }

    $formInputs.each(checkInput);
    $formInputs.on("change", checkInput);
    $formInputs.on("focus", setFocused);
    $formInputs.on("blur", removeFocused);
    $formSelectMenus.on("focus", setFocused);
    $formSelectMenus.on("blur", removeFocused);
  })();

  //Global function top open / close lightboxes

  var PDMLightbox = (function () {
    var $body = $("body");
    //Lightbox reset - This lightbox is empty and present on all pages
    var $lightbox = $(".pdm-lightbox--reset");

    //it's content can be filled from various sources
    //after close, the content is wiped
    var $lightbox_content = $(".pdm-lightbox--reset .pdm-lightbox__content");

    $body.on(
      "click",
      "[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target]",
      function (e) {
        e.preventDefault();

        var classes = $(this).data("lightbox-classes");
        var iframe = $(this).data("lightbox-iframe");
        var blur = $(this).data("lightbox-blur");

        if (iframe) {
          var youtubePattern =
            /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
          var vimeoPattern =
            /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;

          if (youtubePattern.test(iframe)) {
            classes += " youtube-vid";

            replacement =
              '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$1?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" /></div>';

            iframe = iframe.replace(youtubePattern, replacement);
          }

          if (vimeoPattern.test(iframe)) {
            classes += " vimeo-vid";

            replacement =
              '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$1?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" /></div>';

            iframe = iframe.replace(vimeoPattern, replacement);
          }

          $lightbox_content.html(
            '<div class="iframe-wrap">' + iframe + "</div>"
          );
        } else {
          if ($(this).data("lightbox-content")) {
            var content = $(this).data("lightbox-content");
          } else if ($(this).data("lightbox-target")) {
            var target = $(this).data("lightbox-target");
            var content = $("#" + target).html();
          }
          $lightbox_content.html(content);
        }

        if (blur != false) {
          $body.addClass("blur");
        }

        $lightbox.addClass("active").addClass(classes);
      }
    );

    function closeLightbox($lightbox) {
      $lightbox.removeClass("active");
      $("body").removeClass("no-scroll");
      setTimeout(function () {
        $body.removeClass("blur");
      }, 250);
      //wait before removing classes till lightbox closses
      if ($lightbox.hasClass("pdm-lightbox--reset")) {
        setTimeout(function () {
          $lightbox.find(".pdm-lightbox__content").empty();
          $lightbox.attr("class", "pdm-lightbox pdm-lightbox--reset");
        }, 750);
      }
    }

    $(".pdm-lightbox").on("click", function (e) {
      if (e.target == this) {
        closeLightbox($(this));
      }
    });

    $(".pdm-lightbox__close").click(function (e) {
      e.stopPropagation();
      closeLightbox($(this).closest(".pdm-lightbox"));
    });
    return {
      close: closeLightbox,
    };
  })();

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else {
      var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  var productEngraving = (function () {
    var $section = $(".product-engraving");
    if (!$section.length) {
      return;
    }

    //var inputDelay;
   //var $check = $section.closest(".product-options-check");
    //var handle = $check.data("handle");
    //var $engraving = $section.find("#engraving");
    var $font_engraving = $section.find("#font-engraving");
    var $before_engraving = $section.find("#before-engraving");
    var $after_engraving = $section.find("#after-engraving");
    //var $lpx_img = $section.find("#liquidpixel_image");
    /*
    var lpx_baseurl =
      "https://noemie.liquifire.com/noemie?set=prodID[" +
      $section.data("prodid") +
      "]";
    function getMaterialColor() {
      var color = "";

      if ($('.product-options-check__option-select[name="material"]').length) {
        color = $(
          '.product-options-check__option-select[name="material"]'
        ).val();
      }

      if ($('.product-options-check__option-select[name="metal"]').length) {
        color = $('.product-options-check__option-select[name="metal"]').val();
      }

      if (handle == "the-symbol-ring-update") {
        color = "yellow";
      }

      if (color.toLowerCase().indexOf("rose") != -1) {
        color = "rose";
      } else if (color.toLowerCase().indexOf("white") != -1) {
        color = "white";
      } else if (color.toLowerCase().indexOf("yellow") != -1) {
        color = "yellow";
      } else if (color.toLowerCase().indexOf("plat") != -1) {
        color = "plat";
      } else if (color.toLowerCase().indexOf("black") != -1) {
        color = "black";
      } else {
        color = "";
      }
      return color;
    }
    function updateURL() {
      var lpx_src = lpx_baseurl;
      var color = getMaterialColor();

      if ($engraving.val() !== "" && $engraving.length) {
        var engraving = encodeURIComponent($engraving.val());
        lpx_src += ",textline1[" + engraving + "]";
      }

      if ($font_engraving.val() !== "" && $font_engraving.length) {
        var fengraving = encodeURIComponent($font_engraving.val());
        $(".customfont").hide();
        if (fengraving == "other") {
          $(".customfont").show();
          $("#liquidpixel_image").hide();
        }

        lpx_src += ",font1[" + fengraving + "]";
      }

      if ($before_engraving.val() !== "") {
        if (handle == "the-symbol-ring-update") {
          lpx_src += ",art1[" + $before_engraving.val() + "]";
        } else {
          lpx_src += ",icon1[" + $before_engraving.val() + "]";
        }
      }
      if ($after_engraving.val() !== "" && $after_engraving.length) {
        lpx_src += ",icon2[" + $after_engraving.val() + "]";
      }

      lpx_src += ",color1[" + color + "]";
      lpx_src += ",seed[001]&call=url[file:main]&sink";

      if (
        $engraving.val() !== "" ||
        $font_engraving.val() !== "" ||
        $before_engraving.val() !== "" ||
        ($after_engraving.length && $after_engraving.val() !== "")
      ) {
        $lpx_img.show();
        if (fengraving == "other") {
          $lpx_img.hide();
        }
      }

      $lpx_img
        .addClass("loading")
        .find("img")
        .attr("src", lpx_src)
        .on("load", function () {
          $lpx_img.removeClass("loading");
        });
    }

    $engraving.keyup(function () {
      clearTimeout(inputDelay);

      inputDelay = setTimeout(function () {
        updateURL();
      }, 1000);
    });
*/

    $font_engraving.change(function () {
      var $this = $(this);
      var $parent = $this.closest(".engraving__field");
      var selected = $this.find("option:selected").text();
      var $engravingField = $parent.find('input[type="hidden"]');

      $engravingField.val(selected);

      //updateURL();
    });

    $before_engraving.change(function () {
      var $this = $(this);
      var $parent = $this.closest(".engraving__field");
      var selected = $this.find("option:selected").text();
      var $engravingField = $parent.find('input[type="hidden"]');

      $engravingField.val(selected);

      //updateURL();
    });

    $after_engraving.change(function () {
      var $this = $(this);
      var $parent = $this.closest(".engraving__field");
      var selected = $this.find("option:selected").text();
      var $engravingField = $parent.find('input[type="hidden"]');

      $engravingField.val(selected);

      //updateURL();
    });

    return {
      update: function () {},
    };
  })();

  var charmEngraving = (function () {
    var $section = $(".charm-engraving");
    if (!$section.length) {
      return;
    }

    /*
    //var inputDelay;
    //var $check = $section.closest(".product-options-check");
    //var handle = $check.data("handle");

    //var $groups = $section.find(".engraving-group");
    //var $engravings = $section.find(".engraving");
    //var $colors = $section.find(".charm-color");
    
    $engravings.keyup(function () {
      clearTimeout(inputDelay);

      inputDelay = setTimeout(function () {
       
      }, 1000);
    });
    */

    function capitalize(str) {
      if (!str) return str;
      return str[0].toUpperCase() + str.slice(1);
    }

    function setPropertyValue(id, value, metal) {
      var $field = $('[name="properties[' + id + ']"]');
      if ($field.length) {

        $field.val("Color: " + capitalize(metal) + " - Engraving: " + value);
      }
    }

    var $charms = $section.find(".charm-icon");
    $charms.change(function () {
      var selected = $(this).find("option:selected").text();
      if (selected == "None") { 
        selected = "";
      }
      var id = $(this).attr("id");
      var charmColor = $(this).closest(".engraving-group").find(".charm-color").val();
      setPropertyValue(id, selected, charmColor);
    });

    var $textEngravings = $section.find(".engraving__field input.engraving");
    $textEngravings.change(function () {
      var id = $(this).attr("id");
      id = id.replace("engraving-", "Charm-");
      var charmColor = $(this).closest(".engraving-group").find(".charm-color").val();
      setPropertyValue(id, $(this).val(), charmColor);
    });

    return {
      update: function () {},
    };
  })();

  var variantOptionsCheck = (function () {
    var $lastOption;

    function otherOptionsOnSelect($check) {
      var $select = $check.find(".product-options-check__select");
      var variant = $select.val();

      var image = $select.find('option[value="' + variant + '"]').data("image");

      var $images = $(".variant-image");

      const variantMetal = $select
        .find('option[value="' + variant + '"]')
        .attr("data-metal");
      const variantSign = $select
        .find('option[value="' + variant + '"]')
        .attr("data-sign");

      $images.addClass("hidden-image");
      $images
        .filter('[data-master="' + image + '"]')
        .removeClass("hidden-image");

      //            setTimeout(function(){

      if (variantMetal) {
        $images.each(function (i, item) {
          const elImg = $(item).find("img");
          const elVideo = $(item).find("video");

          const imgAlt = elImg.attr("alt");
          const videoAlt = elVideo.attr("alt");

          function checkAltAndShow(alt) {
            if (!alt) return;

            const hasColor =
              alt.includes("Color: ") && alt.includes(variantMetal);
            const hasSign = alt.includes("Sign: ") && alt.includes(variantSign);

            if (
              (hasColor && hasSign) ||
              (hasColor && !alt.includes("Sign: ")) ||
              (hasSign && !alt.includes("Color: "))
            ) {
              $(item).removeClass("hidden-image");
            }
          }

          checkAltAndShow(imgAlt);
          checkAltAndShow(videoAlt);
        });
      }
      var index = -1;
      $(".product-details__images__slider .product-image").each(function () {
        index++;
        if ($(this).data("master") == image) {
          if ($(".product-details__images__slider").data("flickity")) {
            $(".product-details__images__slider").flickity(
              "select",
              index,
              false,
              true
            );
          }
        }
      });
      //            },500);
    }

    function selectClosestVariant() {
      var $check = $lastOption.closest(".product-options-check");
      var $groups = $check.find(".product-options-check__option-group");
      var $productSelect = $check.find(".product-options-check__select");

      var $group = $lastOption.closest(".product-options-check__option-group");
      const $colorValue = $(".product-options-check__option.active").val();
      const $colorType = $group.data("type");
      var type = $group.data("type");
      var value = $lastOption.val();

      const selector =
        "option" +
        "[data-" +
        type +
        '="' +
        value +
        '"]' + // first filter
        "[data-" +
        $colorType +
        '="' +
        $colorValue +
        '"]';
      $productSelect.find(selector).each(function () {
        var $this = $(this);

        if ($this.data("instock") == true) {
          var options = $this.data("options").split(",");
          var count = options.length;

          var $lastOption2;
          $.each(options, function (i, val) {
            var $option = $groups.eq(i).find('button[value="' + val + '"]');
            $lastOption2 = $option;
            selectOption($option, false);
            //                        if (count == (i + 1)) {
            //                        }
          });

          checkAllOptions($lastOption2);
          updateProductSelect($check);

          return false;
        }
      });
    }

    function isMasterVariant($group) {
      return $group.hasClass("product-options-check__option-group--master");
    }

    function handlePreorder($check) {
      var $select = $check.find(".product-options-check__select");
      var $option = $select.find("option:selected");

      $check.find(".preorder-input").remove();
      /* if( $option.data('continue') != undefined && $option.data('continue') == true ){
                $check.prepend('<input type="hidden" class="preorder-input" name="properties[Guaranteed Holiday Delivery]" value="Yes"/>');
            }*/
    }
    function handlePrice($check) {
      var $details = $check.closest(".product-details");
      var $select = $check.find(".product-options-check__select");
      var price = $select.find("option[selected]").data("price");
      var $price = $details.find(".product-price");

      price = price.replace(",", "");

      price = parseFloat(price);

      $price.find(".price").text("$" + price);

      if ($price.find(".save").length) {
        var retail = $price.find(".retail-price").data("price");
        var save = retail - price;
        $price.find(".save").text("Save: $" + save);
      }

      if ($price.find(".product-compare-price").length) {
        var compareAtPrice = $select
          .find("option[selected]")
          .data("compare-at-price");

        var compareAtPriceH = parseFloat(compareAtPrice.replace(",", ""));

        console.log("COMPARE PRICE" + compareAtPrice);

        if(price == compareAtPriceH){
          $price.find('span.price').removeClass('red-color');
          $price.find(".product-compare-price del").hide()
        }else{
          $price.find('span.price').addClass('red-color');
          $price.find(".product-compare-price del").text("$" + compareAtPrice + "").show()
        }
      }

      if ($price.find(".discount").length) {
        var discountedElement = $details.find(".discounted-amount");
        var discountedAmount = $(discountedElement).data("discount-amount");

        var newPrice = price - discountedAmount;
        var newPriceFormatted = "$" + newPrice.toFixed(2); // Format the price

        $price.find(".price").html("$<del>" + price + "</del>");
        $price.find(".discount").text(newPriceFormatted);
      }
    }

    function checkInventory($check) {
      var $details = $check.closest(".product-details");
      var $select = $check.find(".product-options-check__select");
      var stock = $select.find("option[selected]").data("stock");
      var stockMessage = $details.find(".stock-message");

      if (stock) {
        $(stockMessage).show();
      } else {
        $(stockMessage).hide();
      }

      $(stockMessage).find(".variant-quantity").text(stock);
    }

    function updateQueryString(value) {
      var key = "variant";
      var url = window.location.href;

      let updated = "";
      var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

      if (re.test(url)) {
        if (typeof value !== "undefined" && value !== null) {
          updated = url.replace(re, "$1" + key + "=" + value + "$2$3");
        } else {
          hash = url.split("#");
          url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
          if (typeof hash[1] !== "undefined" && hash[1] !== null) {
            url += "#" + hash[1];
          }
          updated = url;
        }
      } else {
        if (typeof value !== "undefined" && value !== null) {
          var separator = url.indexOf("?") !== -1 ? "&" : "?";
          hash = url.split("#");
          url = hash[0] + separator + key + "=" + value;
          if (typeof hash[1] !== "undefined" && hash[1] !== null) {
            url += "#" + hash[1];
          }
          updated = url;
        } else {
          updated = url;
        }
      }

      window.history.replaceState({ path: updated }, "", updated);
    }

    function updateProductSelect($check) {
      var $productSelect = $check.find(".product-options-check__select");
      var $groups = $check.find(".product-options-check__option-group");

      var selectedOptions = [];
      var found = false;

      $groups.each(function () {
        var $group = $(this);
        var $select = $group.find(".product-options-check__option-select");

        selectedOptions.push($select.val());
      });

      $productSelect.find("option").each(function () {
        var $this = $(this);

        if (!$this.data("options")) {
          return;
        }

        var options = $this.data("options").split(",");

        if (options.sort().join(",") == selectedOptions.sort().join(",")) {
          $productSelect.find("option").attr("selected", false);
          $this.attr("selected", true);
          otherOptionsOnSelect($check);
          found = true;

          updateQueryString($this.val()); //important for Unbridaled. This allows you to update the diamond table when a shape is selected and also allow the "add to jewelery" function to work
          //                     window.history.pushState('', '', '?variant=' + $this.val());

          handlePreorder($check);
          handlePrice($check);
          checkInventory($check);

          return false;
        }
      });

      if (found == false) {
        selectClosestVariant();
      }
    }

    function checkAllOptions($option, $exclude) {
      var $check = $option.closest(".product-options-check");
      var $productSelect = $check.find(".product-options-check__select");
      var $groups = $check.find(
        ".product-options-check__option-group:not(.product-options-check__option-group--master)"
      );

      var $master = $(".product-options-check__option-group--master");
      var masterType = $master.data("type");
      var masterVal = $master
        .find(".product-options-check__option-select")
        .val();
      var masterQuery = "[data-" + masterType + '="' + masterVal + '"]';

      $groups.each(function () {
        var $group = $(this);

        if ($exclude == undefined || $group[0] != $exclude[0]) {
          var type = $group.data("type");
          var $options = $group.find(
            ".product-options-check__option-select option"
          );
          var $buttons = $group.find(".product-options-check__option");

          $buttons.addClass("disabled");
          $options.addClass("disabled");
          $options.attr("disabled", true);

          if ($exclude) {
            var excludeType = $exclude.data("type");
            var excludeVal = $exclude
              .find(".product-options-check__option-select")
              .val();
            masterQuery += "[data-" + excludeType + '="' + excludeVal + '"]';
          }

          function enableOptions($option) {
            var $option = $(this);
            var value = $option.val();

            $productSelect
              .find(
                "option" + "[data-" + type + '="' + value + '"]' + masterQuery
              )
              .each(function () {
                if ($(this).data("instock") == true) {
                  $option.removeClass("disabled");
                  $option.attr("disabled", false);
                }
              });
          }

          $buttons.each(enableOptions);
          $options.each(enableOptions);
        }
      });

      updateProductSelect($check);
    }

    function selectOption($option, check) {
      var $check = $option.closest(".product-options-check");
      var $mselect = $check.find(".product-options-check__select");
      var $group = $option.closest(".product-options-check__option-group");
      var type = $group.data("type");
      var $labels = $group.find("label");
      var $buttons = $group.find(".product-options-check__option");
      var $select = $group.find(".product-options-check__option-select");
      var $selectOptions = $select.find("option");
      var $selectedOptionText = $group.find(".selected-option");
      var val = $option.val();

      //            console.log(val);

      var $selectedButton = $buttons.filter('[value="' + val + '"]');

      if ($selectedButton.hasClass("disabled")) {
        return;
      }

      if (val != null) {
        if (val.indexOf("Gold") !== -1) {
          const dataTitle = $selectedOptionText
            ? $selectedOptionText.attr("data-title")
            : "";
          const dataIsLab = $selectedOptionText.attr("data-is-lab") == "true";

          if (
            dataTitle.length &&
            (dataTitle.indexOf("14K") != -1 ||
              dataTitle.indexOf("Foundation") != -1 ||
              dataTitle.indexOf("Essentials") != -1 ||
              dataTitle.indexOf("Momentum") != -1 ||
              dataTitle.indexOf("Legacy") != -1 ||
              dataIsLab)
          ) {
            $selectedOptionText.text("14 Karat " + val);
          } else {
            $selectedOptionText.text("18 Karat " + val);
          }
        } else {
          $selectedOptionText.text(val);
        }
      }

      //$labels and .parent is for swatch selects to have the class added to the parent instead of button
      $buttons.removeClass("active");
      $labels.removeClass("active");
      $selectedButton.addClass("active");
      $selectedButton.parent().addClass("active");

      $selectOptions.attr("selected", false);
      $selectOptions.filter('[value="' + val + '"]').attr("selected", true);
      $select.val(val);

      $lastOption = $option;

      if (check == true) {
        if (isMasterVariant($group)) {
          checkAllOptions($option);
        } else {
          checkAllOptions($option, $group);
        }
      }

/*
      if ($(".product-engraving").length) {
        productEngraving.update();
      }

      if ($(".charm-engraving").length) {
        charmEngraving.update();
      }
*/
    }

    $("body").on("click", ".product-options-check__option", function () {
      selectOption($(this), true);
    });

    $("body").on(
      "change",
      ".product-options-check__option-select",
      function () {
        selectOption($(this), true);
      }
    );

    function defaultVariantSelect($el) {
      var variant = urlParams.get("variant");

      if (variant) {
        var currentOptions = $(".product-options-check__select")
          .find('option[value="' + variant + '"]')
          .data("options");

        currentOptions = currentOptions.split(",");
        if (
          currentOptions[1] === "3 - Pinky Ring (0.50 Carats)" ||
          currentOptions[1] == "3.5 - Pinky Ring (0.50 Carats)"
        ) {
          const label = document.querySelector(
            ".selected-option.selected-option--size"
          );
          console.log("load");
          const firstSelectItem = $(
            ".product-options-check__option-select[name='size']"
          )
            .first()
            .children(":not(:disabled)")
            .first();
          currentOptions[1] = firstSelectItem.val();
        }
        console.log(currentOptions);
        $(".product-options-check__option-group").each(function ($i) {
          console.log($(this).data("type"));
          $(this)
            .find(".product-options-check__option")
            .each(function () {
              console.log($(this).val());
              if ($(this).val() == currentOptions[$i]) {
                $(this).click();
                console.log("click");
                return false;
              }
            });
        });
        updateProductSelect($(".product-options-check"));
      } else {
        $el.click();
        var $check = $el.closest(".product-options-check");
        var type = $check.data("type");

        // if( type == 'Ring' ){

        //     var $sizeOptions = $check.find('.product-options-check__option-group--size');

        //     var $option7 = $sizeOptions.find('option[value="7"]');

        //     if( $option7.length ){
        //         $sizeOptions.find('select').val(7);
        //         $sizeOptions.find('select').trigger('change');
        //     }

        // }
      }
    }

    function checkAvailableMasterOptions($group) {
      var $check = $group.closest(".product-options-check");
      var $productSelect = $check.find(".product-options-check__select");
      var type = $group.data("type");
      var $buttons = $group.find(".product-options-check__option");

      $buttons.addClass("disabled");

      $buttons.each(function () {
        var $this = $(this);
        var value = $this.val();

        $productSelect
          .find("option" + "[data-" + type + '="' + value + '"]')
          .each(function () {
            if ($(this).data("instock") == true) {
              $this.removeClass("disabled");
              return false;
            }
          });
      });

      defaultVariantSelect($buttons.filter(":not(.disabled)").first());
    }

    $(".product-options-check").each(function () {
      var $group = $(this).find(".product-options-check__option-group").first();
      checkAvailableMasterOptions($group);
    });
  })();

  var desktopQuery = window.matchMedia("(min-width: 960px)");

  var header = (function () {
    var $header = $(".gheader");
    var $banner = $(".gheader__banner");
    var $navContainer = $(".gheader__nav");

    function headerHeight() {
      var height = $navContainer.outerHeight();
      if ($banner.length) {
        height += $banner.outerHeight();
      }
      return height;
    }

    //        gsap.set($header,{
    //            position:'fixed',
    //        });
    //
    //        $('#scroll-container').prepend('<div class="gheader__placeholder"></div>');
    //
    //        $(window).resize(function(){
    //            gsap.set('.gheader__placeholder',{
    //                height:headerHeight(),
    //            });
    //        }).trigger('resize');

    //        var previousScroll = 0;
    //        $(window).scroll(function(){
    //            var stickyTop = $header.outerHeight()*2;
    //            var currentScroll = $(this).scrollTop();
    //            if (currentScroll > previousScroll && currentScroll > stickyTop){
    //                $header.addClass('nav-hide');
    //            } else {
    //                $header.removeClass('nav-hide');
    //            }
    //            previousScroll = currentScroll;
    //        });

    var $mobileToggle = $(".menu-burger");
    var $mobileNav = $(".gheader__mobile");
    var $mobileDrops = $mobileNav.find(".dropdown");

    $mobileDrops.click(function (e) {
      if (desktopQuery.matches) {
        return;
      }

      e.preventDefault();

      var $this = $(this);

      $this.toggleClass("active");
      $this.next().slideToggle();
    });

    $mobileToggle.click(function () {
      var $this = $(this);

      if ($this.hasClass("active")) {
        $("body").removeClass("noScroll");
        gsap.to($mobileNav, {
          x: "-100%",
          duration: 0.5,
        });
      } else {
        $("body").addClass("noScroll");
        gsap.to($mobileNav, {
          x: 0,
          duration: 0.5,
        });
      }
    });

    $dropdowns = $(".dropdown-menu.show-image");
    $dropdownImages = $(".dropdown-menu.show-image li[data-image]");

    $dropdowns.each(function () {
      var $this = $(this);
      var fistImage = $this.find("li[data-image]").data("image");

      $this.append(
        '<div class="image-container"><img class="lazy" data-src="' +
          fistImage +
          '"></div>'
      );

      LazyLoading.update();
    });

    $dropdownImages.hover(function () {
      var $this = $(this);
      var fistImage = $this.data("image");
      var $dropdown = $this.closest(".dropdown-menu.show-image");

      $dropdown.find("img").attr("src", fistImage);
    });

    $searchToggle = $(".search-icon");
    $searchBar = $(".search-form");

    $searchToggle.click(function () {
      $searchBar.toggleClass("active");
      //            $mobileToggle.click();
    });
  })();

  //    var heroMain = (function () {
  //
  //        var $hero = $('.hero-main');
  //
  //        if (!$hero.length) {
  //            return;
  //        }
  //
  //    }());

  var USPs = (function () {
    var $usps = $(".usps-row ul");

    if (!$usps.length) {
      return;
    }

    ScrollTrigger.matchMedia({
      "(max-width: 959px)": function () {
        $usps.each(function () {
          var $this = $(this);
          var containerWidth = 0;
          var $slides = $this.find("li");

          $slides.each(function () {
            containerWidth += $(this).outerWidth();
          });

          $slides.each(function () {
            var $slide = $(this);
            var leftBounds = -($slide.outerWidth() + $slide.offset().left);
            var wrapFunc = gsap.utils.unitize(
              gsap.utils.wrap(leftBounds, containerWidth + leftBounds)
            );
            gsap.to($slide, {
              x: -containerWidth,
              ease: "none",
              delay: 0.5,
              duration: 12,
              repeat: -1,
              modifiers: {
                x: wrapFunc,
              },
            });
          });
        });
      },
    });
  })();

  var fifty2img = (function () {
    var $els = $(".fifty-2img:not(.special)");

    if (!$els.length) {
      return;
    }

    var $allimages = $els.find(".fifty-2img_image");

    ScrollTrigger.saveStyles($allimages);

    ScrollTrigger.matchMedia({
      "(min-width: 960px)": function () {
        $els.each(function () {
          var $trigger = $(this);
          var $images = $trigger.find(".fifty-2img_image");

          gsap.to($images, {
            y: (i, el) =>
              (1 - parseFloat($(el).data("speed"))) * $trigger.outerHeight(),
            ease: "none",
            scrollTrigger: {
              trigger: $trigger,
              start: "top center",
              end: "bottom center-=200px",
              invalidateOnRefresh: true,
              scrub: 0,
              markers: false,
            },
          });
        });
      },
    });
  })();

  var calloutParallax = (function () {
    var $els = $(".callout-parallax");

    if (!$els.length) {
      return;
    }

    //        var $allimages = $els.find('.callout-parallax__image');
    //        ScrollTrigger.saveStyles($allimages);

    function startTrigger() {
      if (desktopQuery.matches) {
        return "top center";
      } else {
        return "top center+=100";
      }
    }

    $els.each(function () {
      var $trigger = $(this);
      var $images = $trigger.find(".callout-parallax__image");

      gsap.to($images, {
        y: (i, el) =>
          (1 - parseFloat($(el).data("speed"))) * $trigger.outerHeight(),
        ease: "none",
        scrollTrigger: {
          trigger: $trigger,
          start: startTrigger,
          end: "bottom center-=200px",
          invalidateOnRefresh: true,
          scrub: 0,
          markers: false,
        },
      });
    });
  })();

  var productCard = (function () {
    var $loop = $(".product-card");

    if (!$loop.length) {
      return;
    }

    $("body").on("click", ".material__swatches button", function () {
      var $this = $(this);

      if ($this.hasClass("disabled")) {
        return false;
      }

      var image = $this.data("image");
      var $card = $this.parents(".product-card");
      var $swatches = $card.find(".material__swatches button");
      var $ul = $this.parents(".material__swatches");
      var $labels = $ul.find("label");
      var $image = $card.find(".product-card__thumb img.variant-image");
      $labels.removeClass("active");
      $this.parent().addClass("active");

      $image.parent().addClass("variant-active");
      $image.attr("src", image);
    });
  })();

  var featCol = (function () {
    var $nav = $(".feat-collections__nav button");

    if (!$nav.length) {
      return;
    }

    var $sliderContainers = $(".feat-collections .feat-collections__slider");
    var $activeSlider = $sliderContainers.filter(".active");
    var $sliders = $(".feat-collections .product-loop");

    function animateSlides($activeSlider) {
      var $slides = $activeSlider.find(".product-card");
      gsap.set($activeSlider, {
        opacity: 0,
      });
      gsap.set($slides, {
        x: "100%",
      });
      gsap.to($activeSlider, {
        delay: 0.25,
        opacity: 1,
        duration: 1.5,
      });
      gsap.to($slides, {
        x: 0,
        duration: 1,
        stagger: 0.1,
      });
    }

    animateSlides($activeSlider);

    $sliders.each(function () {
      var $this = $(this);

      $this.flickity({
        cellAlign: "left",
        groupCells: false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
      });

      $this
        .parent()
        .find(".feat-collections__slider__nav button")
        .click(function () {
          if ($(this).hasClass("next")) {
            $this.flickity("next");
          } else {
            $this.flickity("previous");
          }
        });
    });

    $nav.click(function () {
      var $this = $(this);

      if ($this.hasClass("active")) {
        return;
      }

      var target = $this.data("target");
      var $activeSlider = $sliderContainers.filter(
        '[data-handle="' + target + '"]'
      );

      animateSlides($activeSlider);

      $nav.removeClass("active");
      $this.addClass("active");

      $sliderContainers.removeClass("active");
      $activeSlider.addClass("active").find(".product-loop").flickity("resize");
    });
  })();

  var designItems = (function () {
    var $nav = $(".custom-design-images-titles button");
    console.log($nav, "nav");

    if (!$nav.length) {
      return;
    }

    var $sliderContainers = $(".custom-design-image-list");
    var $activeSlider = $sliderContainers.filter(".active");
    var $sliders = $(".custom-design-image-list");

    function animateSlides($activeSlider) {
      var $slides = $activeSlider.find(".image-item");
      gsap.set($activeSlider, {
        opacity: 0,
      });
      gsap.set($slides, {
        x: "100%",
      });
      gsap.to($activeSlider, {
        delay: 0.25,
        opacity: 1,
        duration: 1.5,
      });
      gsap.to($slides, {
        x: 0,
        duration: 1,
        stagger: 0.1,
      });
    }

    animateSlides($activeSlider);

    $sliders.each(function () {
      var $this = $(this);

      $this.flickity({
        cellAlign: "left",
        groupCells: false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
      });

      $this
        .parent()
        .find(".custom-design-image__nav button")
        .click(function () {
          if ($(this).hasClass("next")) {
            $this.flickity("next");
          } else {
            $this.flickity("previous");
          }
        });
    });

    $nav.click(function () {
      var $this = $(this);
      console.log("click", $this);

      if ($this.hasClass("active")) {
        return;
      }

      var target = $this.data("target");
      console.log(target, "target");
      var $activeSlider = $sliderContainers.filter(
        '[data-handle="' + target + '"]'
      );
      console.log($activeSlider, "active");

      animateSlides($activeSlider);

      $nav.removeClass("active");
      $this.addClass("active");

      $sliderContainers.removeClass("active");
      $activeSlider.addClass("active").flickity("resize");
    });
  })();

  var gallerySlider = (function () {
    $sliders = $(".gallery-slider__slider");

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);

      $this.flickity({
        cellAlign: "left",
        groupCells: true,
        pageDots: false,
        prevNextButtons: false,
      });

      $this
        .parent()
        .find(".gallery-slider__nav button")
        .click(function () {
          if ($(this).hasClass("next")) {
            $this.flickity("next");
          } else {
            $this.flickity("previous");
          }
        });
    });
  })();

  var audioToggle = (function () {
    var $toggle = $(".toggle-audio");

    if (!$toggle.length) {
      return;
    }

    $toggle.click(function () {
      var $video = $(this).closest(".video-wrap").find("video");

      if ($video.prop("muted")) {
        $video.prop("muted", false);
      } else {
        $video.prop("muted", true);
      }
    });
  })();

  function klaviyoSubscribe(listID, email, source, callback) {
    // send Identify request to cookie the browser
    var _learnq = _learnq || [];
    _learnq.push(["identify", { $email: email }]);

    $.ajax({
      type: "POST",
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      data: `g=${listID}&email=${encodeURIComponent(
        email
      )}&$fields=$source&$source=${source}`,
      contentType: "application/x-www-form-urlencoded",
      error: function (err) {
        console.log("Could not connect to Klaviyo.");
        return err;
      },
      success: callback,
    });
  }

  var newsletter = (function () {
    var $signup = $(".signup-block form");

    if (!$signup.length) {
      return;
    }

    function handleResponse(data) {
      console.log(data);
      if (data.success == true) {
        $signup.find("input").hide();
        $signup.append(
          '<p class="message message--sucess">Thanks for subscribing!</p>'
        );
      }
    }

    $signup.submit(function (e) {
      e.preventDefault();

      var $this = $(this);
      var email = $(this).find(".email").val();

      klaviyoSubscribe(
        "MiWHFU",
        email,
        "Website Newsletter Signup",
        handleResponse
      );
    });
  })();

  var comapeHero = (function () {
    var $toggle = $(".compare-images");

    if (!$toggle.length) {
      return;
    }

    $toggle.twentytwenty();
  })();

  var galSlider2 = (function () {
    var $imgSlider = $(".gallery-slider-v2__slider");

    $imgSlider.each(function () {
      var $this = $(this);

      $this.flickity({
        cellAlign: "left",
        groupCells: false,
        prevNextButtons: false,
        wrapAround: true,
      });

      $this
        .parent()
        .find(".gallery-slider-v2__nav button")
        .click(function () {
          if ($(this).hasClass("next")) {
            $this.flickity("next");
          } else {
            $this.flickity("previous");
          }
        });
    });
  })();

  var nameEngraving = (function () {
    var $engraver = $(".name-engraver");

    if (!$engraver.length) {
      return;
    }

    var $input = $engraver.find("#name-engraving");
    // var $output = $engraver.find('.engraver-preview');

    var $letters = $engraver
      .closest(".product-options-check")
      .find('select[name="number-of-letters"]');
    // console.log($letters);

    var length = 1;

    var text = "Write up to ";

    $letters.change(function () {
      length = $letters.val();
      var newtext = text + length + " character";

      newtext += length > 1 ? "s:" : ":";

      $engraver.find('label[for="name-engraving"]').text(newtext);

      $input.attr("maxlength", length);

      $input.val($input.val().substring(0, length));
      $output.text($input.val().substring(0, length));
    });

    $("#name-engraving-font").change(function () {
      var font = $(this).val();
      console.log(font);
      $input.data("font", font);
      $input.attr("data-font", font);
      console.log($input);
    });

    // $input.keyup(function(){
    //     $output.text($input.val().substring(0, length));
    // });

    //        $input.change(function(){
    //            $output.val($input.val());
    //        });
  })();

  var customRingBuilder = (function () {
    //        var $shapeInput = $('.product-customizer-option[data-option-name="diamond-shape"] input');
    //
    //        if (!$shapeInput.length) { return; }
    //
    //        $shapeInput.change(function(){
    //
    //            var $this = $(this),
    //            value = $this.val().toLowerCase(),
    //            url = "/products/custom-ring-builder-" + value;
    //
    //            window.location = url;
    //
    //        });
    //        function hideOptions(){
    //            $('[data-carat="carat"]').hide();
    //        }
    //
    //        hideOptions();
  })();

  var ProductPage = (function () {
    var $section = $(".product-details");
    if (!$section.length) {
      return;
    }

    var $check = $section.find(".product-options-check");
    var handle = $check.data("handle");

    function loadVideos() {
      var replacementTag = "source";
      $("datasource").each(function () {
        var outer = this.outerHTML;
        // Replace opening tag
        var regex = new RegExp("<" + this.tagName, "i");
        var newTag = outer.replace(regex, "<" + replacementTag);

        // Replace closing tag
        regex = new RegExp("</" + this.tagName, "i");
        newTag = newTag.replace(regex, "</" + replacementTag);

        $(this).replaceWith(newTag);
      });
    }

    var ImageSlider = (function () {
      var $imgSlider = $section.find(".product-details__images__slider");

      $imgSlider.flickity({
        cellAlign: "left",
        groupCells: true,
        prevNextButtons: true,
        watchCSS: true,
        pageDots: false,
        wrapAround: true,
      });

      if ($(window).width() < 960) {
        $imgSlider.on("change.flickity", function (event, index) {
          if ($(".product-image").eq(index).hasClass("video")) {
            loadVideos();
          }
        });
      } else {
        setTimeout(function () {
          loadVideos();
        }, 3000);
      }

      /*   
            $imgSlider.parent().find('.product-details__images__nav button').click(function () {
                if ($(this).hasClass('next')) {
                    $imgSlider.flickity('next');
                } else {
                    $imgSlider.flickity('previous');
                }
            });*/

      // Zoom / Magnify on desktop https://github.com/strawdynamics/drift
      (() => {
        const mq = window.matchMedia('(max-width: 959px)');
        const instances = new Map();

        const driftOptions = {
          inlineOffsetX: 0,
          inlineOffsetY: 0,
          zoomFactor: 2
        };

        function destroyAll() {
          instances.forEach(inst => inst.destroy());
          instances.clear();
        }

        function createAll() {
          const imgs = document.querySelectorAll('.product-details__images__slider img.zoom-image');
          imgs.forEach(img => {
            if (!instances.has(img)) {
              instances.set(img, new Drift(img, driftOptions));
            }
          });

          instances.forEach((inst, img) => {
            if (!img.isConnected) {
              inst.destroy();
              instances.delete(img);
            }
          });
        }

        function sync() {
          if (mq.matches) destroyAll();
          else createAll();
        }

        // Init
        window.addEventListener('load', () => requestAnimationFrame(sync));

        // Breakpoint changes
        if (mq.addEventListener) mq.addEventListener('change', () => requestAnimationFrame(sync));
        else mq.addListener(() => requestAnimationFrame(sync)); // Safari viejo

        window.addEventListener('orientationchange', () => requestAnimationFrame(sync));

        let t;
        window.addEventListener('resize', () => {
          clearTimeout(t);
          t = setTimeout(() => requestAnimationFrame(sync), 150);
        });
      })();

      // Zoom on mobile
      document.querySelectorAll('.product-details__images__slider button.mob-zoom').forEach(button => {
        button.addEventListener('click', () => {
          if (window.innerWidth >= 960) return;

          const img = button.closest('.positioner').querySelector('img.zoom-image');
          const src = img.getAttribute('data-zoom') || img.src;

          const zoomedImg = document.createElement('img');
          zoomedImg.src = src;
          zoomedImg.style.width = '100%';
          zoomedImg.style.height = 'auto';

          const overlay = document.createElement('div');
          overlay.style.position = 'fixed';
          overlay.style.top = 0;
          overlay.style.left = 0;
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          overlay.style.display = 'flex';
          overlay.style.alignItems = 'center';
          overlay.style.justifyContent = 'center';
          overlay.style.zIndex = 10000;

          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.setAttribute('aria-label', 'Cerrar');
          closeBtn.textContent = '×';
          closeBtn.style.position = 'absolute';
          closeBtn.style.top = '16px';
          closeBtn.style.right = '16px';
          closeBtn.style.width = '40px';
          closeBtn.style.height = '40px';
          closeBtn.style.border = '0';
          closeBtn.style.borderRadius = '999px';
          closeBtn.style.background = 'rgba(255, 255, 255, 0.9)';
          closeBtn.style.color = '#111';
          closeBtn.style.fontSize = '28px';
          closeBtn.style.lineHeight = '1';
          closeBtn.style.cursor = 'pointer';

          const previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';

          const closeOverlay = () => {
            if (overlay.parentNode) {
              document.body.removeChild(overlay);
            }
            document.body.style.overflow = previousBodyOverflow;
          };

          closeBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            closeOverlay();
          });

          overlay.appendChild(zoomedImg);
          overlay.appendChild(closeBtn);

          document.body.appendChild(overlay);

        });
      });

    })();

    var EngravingDropdowns = (function () {
      var $dropdowns = $section.find(".engraving-icons select");

      if (!$dropdowns.length) {
        return;
      }
      //TODO: Fede's Note: This needs to be fixed! The code shouldn't use the product's handle as a condition for specific functionality. This is very brittle and will break if we change the handle or want to reuse this code for another product. We should find a better way to determine when to apply this special logic, such as using a specific class on the product page or a data attribute.
      var specialArray = [
        "custom-letter-necklace",
        "custom-engraved-heart-necklace",
        "diamond-medallion-bracelet",
        "diamond-medallion-necklace-1",
      ];

      function formatSelect(state) {
        if (!state.id) {
          return state.text;
        }

        var $state = $(
          "<span><span><img src=" +
            state.element.dataset.imagesrc +
            "/></span> " +
            state.text +
            "</span>"
        );
        return $state;
      }

      $dropdowns.select2({
        templateResult: formatSelect,
        templateSelection: formatSelect,
      });

      $dropdowns.on("select2:select", function (e) {
        var el = e.params.data.element;
        var icon_src = el.dataset.imagesrc;
        var val = el.value;
        var $group = $(el).closest(".engraving-group");
        var $engravingText = $group.find(".engraving");
        var $engravingFont = $group.find(".font-engraving");

        var selected_html = '<img src="' + icon_src + '" title=' + val + "/>";

        if (icon_src == undefined) {
          selected_html = "(" + el.innerText + ")";
        }

        $(el).parent().parent().find(".selected-option").html(selected_html);

        if (jQuery.inArray(handle, specialArray) > -1) {
          if (val == "") {
            $engravingText.removeAttr("readonly");
          } else {
            $engravingText.attr("readonly", true);
          }
        }
      });

      $(".engraving").change(function () {
        var $group = $(this).closest(".engraving-group");
        var $groupDropdowns = $group.find(".engraving-icons select");
        var $groupFontSelect = $group.find(".engraving-fonts select");

        console.log("font", $groupFontSelect);

        if (jQuery.inArray(handle, specialArray) > -1) {
          if ($(this).val() == "") {
            $groupDropdowns.removeAttr("disabled");
          } else {
            $groupDropdowns.attr("disabled", true);
          }
        }
      });
    })();

    var view360 = (function () {
      $(".view-360btn").on("click", function (e) {
        e.preventDefault();
        var $lightbox = $(".lightbox-360view");
        var $iframe = $lightbox.find("iframe");
        var src = $iframe.data("src");
        $iframe.attr("src", src);
        $lightbox.addClass("active");
        return false;
      });
    })();

    var share = (function () {
      $(".social-share button,.social-share a").click(function () {
        $(".social-share").toggleClass("active");
      });
    })();

    var textUs = (function () {
      $(".product-details__sizer button").on("click", function () {
        var ua = navigator.userAgent.toLowerCase();
        var url = "";
        var tel = $(this).attr("data-tel");

        var body = $(this).attr("data-content");
        body = encodeURIComponent(body);

        var referer_url = window.location.href;

        if (ua.match(/(ipad|iphone|ipod)/g)) {
          url = "sms:" + tel + "&body=" + body;
        } else {
          url = "sms:" + tel + "?body=" + body;
        }

        window.location = url;
      });
    })();

  })();

  var yotpoLoad = (function () {
    var $section = $(".yotpo-reviews-section");

    if (!$section.length) {
      return;
    }

    var yotpoCheck = setInterval(function () {
      if ($section.find(".scroller").length) {
        clearInterval(yotpoCheck);
        refreshSmooth.init();
      }
    }, 100);
  })();

  var featuredProducts = (function () {
    $sliders = $(".featured-products__slider");

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);

      $this.flickity({
        cellAlign: "left",
        groupCells: true,
        pageDots: false,
        prevNextButtons: false,
      });

      $this
        .parent()
        .find(".featured-products__nav button")
        .click(function () {
          if ($(this).hasClass("next")) {
            $this.flickity("next");
          } else {
            $this.flickity("previous");
          }
        });
    });
  })();

  var similarProducts = (function () {
    $sliders = $(".similar-products__slider");

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);

      $this.flickity({
        cellAlign: "left",
        groupCells: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
      });

      $this
        .parent()
        .find(".similar-products__nav button")
        .click(function () {
          if ($(this).hasClass("next")) {
            $this.flickity("next");
          } else {
            $this.flickity("previous");
          }
        });
    });
  })();

  var costPerWear = (function () {
    var $itemRange = $("#itemRange");

    if (!$("#itemRange").length) {
      return;
    }

    // $("#itemRange").slider({
    //     value: 0,

    // });
    $("#itemRange").on("change", function () {
      costPerWear($("#itemRange").val());
    });

    $(document).on("keyup change", "#itemPrice", function () {
      if ($(this).val() != null && $(this).val() != "" && $(this).val() != 0) {
        if (
          $("#itemMaintenance").val() != null &&
          $("#itemMaintenance").val() != "" &&
          $("#itemMaintenance").val() != 0
        ) {
          var maintenanceCost = $("#itemMaintenance").val();
          var noOfYear = $("#itemYear").val();
          var totalCostOfMaintenance = maintenanceCost * noOfYear;
          var itemPrice = totalCostOfMaintenance + parseInt($(this).val());
          var costPerWear = itemPrice / (noOfYear * $("#itemRange").val());
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        } else if (
          $("#itemYear").val() != null &&
          $("#itemYear").val() != "" &&
          $("#itemYear").val() != 0
        ) {
          var noOfYear = $("#itemYear").val();
          var itemPrice = parseInt($(this).val());
          var costPerWear = itemPrice / (noOfYear * $("#itemRange").val());
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        }
      }
    });

    $(document).on("keyup change", "#itemMaintenance", function () {
      if (
        $("#itemPrice").val() != null &&
        $("#itemPrice").val() != "" &&
        $("#itemPrice").val() != 0
      ) {
        if (
          $(this).val() != null &&
          $(this).val() != "" &&
          $(this).val() != 0
        ) {
          var maintenanceCost = $(this).val();
          var noOfYear = $("#itemYear").val();
          var totalCostOfMaintenance = maintenanceCost * noOfYear;
          var itemPrice =
            totalCostOfMaintenance + parseInt($("#itemPrice").val());
          var costPerWear = itemPrice / (noOfYear * $("#itemRange").val());
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        } else if (
          $("#itemYear").val() != null &&
          $("#itemYear").val() != "" &&
          $("#itemYear").val() != 0
        ) {
          var noOfYear = $("#itemYear").val();
          var itemPrice = parseInt($("#itemPrice").val());
          var costPerWear = itemPrice / (noOfYear * $("#itemRange").val());
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        }
      }
    });

    $(document).on("keyup change", "#itemYear", function () {
      if (
        $("#itemPrice").val() != null &&
        $("#itemPrice").val() != "" &&
        $("#itemPrice").val() != 0
      ) {
        if (
          $("#itemMaintenance").val() != null &&
          $("#itemMaintenance").val() != "" &&
          $("#itemMaintenance").val() != 0
        ) {
          var maintenanceCost = $("#itemMaintenance").val();
          var noOfYear = $("#itemYear").val();
          var totalCostOfMaintenance = maintenanceCost * noOfYear;
          var itemPrice =
            totalCostOfMaintenance + parseInt($("#itemPrice").val());
          var costPerWear = itemPrice / (noOfYear * $("#itemRange").val());
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        } else if (
          $(this).val() != null &&
          $(this).val() != "" &&
          $(this).val() != 0
        ) {
          var noOfYear = $(this).val();
          var itemPrice = parseInt($("#itemPrice").val());
          var costPerWear = itemPrice / (noOfYear * $("#itemRange").val());
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        }
      }
    });

    $(document).on(
      "wheel",
      ".cost-per-wear-form input[type=number]",
      function (e) {
        $(this).blur();
      }
    );

    function costPerWear(value) {
      if (
        $("#itemPrice").val() != null &&
        $("#itemPrice").val() != "" &&
        $("#itemPrice").val() != 0
      ) {
        if (
          $("#itemMaintenance").val() != null &&
          $("#itemMaintenance").val() != "" &&
          $("#itemMaintenance").val() != 0
        ) {
          var maintenanceCost = $("#itemMaintenance").val();
          var noOfYear = $("#itemYear").val();
          var totalCostOfMaintenance = maintenanceCost * noOfYear;
          var itemPrice =
            totalCostOfMaintenance + parseInt($("#itemPrice").val());
          var costPerWear = itemPrice / (noOfYear * value);
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        } else if (
          $("#itemYear").val() != null &&
          $("#itemYear").val() != "" &&
          $("#itemYear").val() != 0
        ) {
          var noOfYear = $("#itemYear").val();
          var itemPrice = parseInt($("#itemPrice").val());
          var costPerWear = itemPrice / (noOfYear * value);
          if (isFinite(costPerWear)) {
            $(".cost-per-wear__result span").text(
              "$" + costPerWear.toFixed(2).replace(".00", "").replace(",", "")
            );
          } else {
            $(".cost-per-wear__result span").text("--");
          }
        }
      }
    }
  })();

  var estShipping = (function () {
    var shippingEstimator = $(".shipping-estimator");

    if (!shippingEstimator.length) {
      return;
    }

    var shippingEstimatorSubmit = shippingEstimator.find(
      ".shipping-estimator__submit"
    );

    new Shopify.CountryProvinceSelector("address_country", "address_province", {
      hideElement: "address_province_container",
    });

    function showShippingEstimateError(results) {
      var $results = $(".shipping-estimator__results");
      var $title = $results.find(".shipping-estimator__title");
      var $list = $results.find(".shipping-estimator__list");

      $list.empty();

      $title.text("There are some errors with your submission:");

      $list.append("<li>" + results.zip[0] + "</li>");

      $results.show();
    }

    function showShippingEstimateSuccess(results) {
      var $results = $(".shipping-estimator__results");
      var $title = $results.find(".shipping-estimator__title");
      var $list = $results.find(".shipping-estimator__list");

      $list.empty();

      $title.text("Available shipping rates:");

      $.each(results, function (i, result) {
        var price = result.price;

        if (price == 0.0) {
          price = "FREE";
        } else {
          price = "$" + price;
        }

        $list.append(
          "<li>" + result.name + ": <strong>" + price + "</strong></li>"
        );
      });

      $results.show();
    }

    $(".shipping-estimator__form").submit(function (e) {
      e.preventDefault();

      shippingEstimatorSubmit.text("Estimating...");

      $.ajax({
        method: "GET",
        url: "/cart/shipping_rates.json",
        data: {
          shipping_address: {
            country: shippingEstimator.find("#address_country").val(),
            province: shippingEstimator.find("#address_province").val(),
            zip: shippingEstimator.find("#address_zip").val(),
          },
        },
        error: function (results) {
          shippingEstimatorSubmit.text("Estimate");

          var response = results.responseJSON;

          showShippingEstimateError(response);
        },
        success: function (results) {
          shippingEstimatorSubmit.text("Estimate");

          var response = results.shipping_rates;

          showShippingEstimateSuccess(response);
        },
      });

      new Shopify.CountryProvinceSelector(
        "address_country",
        "address_province",
        {
          hideElement: "address_province_container",
        }
      );
    });
  })();

  var stickyATC = (function () {
    var $floatingATC = $(".floating-atc");

    if (!$floatingATC.length) {
      return;
    }

    gsap.to($floatingATC, {
      y: 0,
      scrollTrigger: {
        trigger: $(".product-details .product-options-check"),
        start: "bottom top-=100",
        //                invalidateOnRefresh: true,
        //                scrub: 0,
        toggleActions: "restart none none reverse",
        markers: false,
      },
    });

    var $dropdowns = $floatingATC.find("select");

    function formatSelect(state) {
      if (!state.id) {
        return state.text;
      }

      var $option = $(state.element);
      var label = $option.closest("select").data("name");

      var $state = $(
        "<strong>" + label + ":</strong> <span>" + state.text + "</span>"
      );
      return $state;
    }

    $dropdowns.select2({
      templateResult: formatSelect,
      templateSelection: formatSelect,
      dropdownCssClass: "sticky-atc-select-dropdown",
      minimumResultsForSearch: -1,
    });
  })();

  var CartPopup = (function () {
    var $icon = $(".cart-icon");
    var $cart = $(".cart-pop");
    var $body = $("body");

    function updateCart(callback) {
      $.getJSON("/cart.js", function (data) {
        var subtotal = data.total_price;
        var count = data.item_count;
        var html = "";

        $.each(data.items, function (index, item) {
          var image = item.image.split(".");
          var img_ext = image[image.length - 1];
          var image = item.image.replace(
            "." + img_ext,
            "_64x64_crop_center." + img_ext
          );

          html += `<div class="cart-item">
                        <div class="cart-item__img">
                            <a class="positioner" href="${item.url}">
                                <img src="${image}" width="64" height="64" loading="lazy"/>
                            </a>
                        </div>
                        <span class="cart-item__title"><a href="${item.url}">${
            item.quantity
          } x ${item.product_title}</a></span>
                        <span class="cart-item__price">${Shopify.formatMoney(
                          item.price
                        )}</span>
                    </div>`;
        });

        $cart.find(".cart-pop__items").html(html);
        $cart.find(".cart-pop__total span").text(Shopify.formatMoney(subtotal));
        callback();
      });
    }

    $icon.click(function () {
      $cart.toggleClass("active");
      $body.toggleClass("body--overlay");
    });

    $("#viewport").click(function () {
      if ($cart.hasClass("active")) {
        $cart.removeClass("active");
        $body.removeClass("body--overlay");
      }
    });

    return {
      update: updateCart,
      open: function () {
        $cart.addClass("active");
        $body.addClass("body--overlay");
      },
    };
  })();

  var AjaxAddToCart = (function () {
    var $ATC = $(".atc-btn");

    if (!$ATC.length) {
      return;
    }

    $(document).on("click", ".atc-btn", function (e) {
      if (window.popupenable == true) {
        e.preventDefault();
        var formdata = $(e.currentTarget.form).serialize();

        $(e.currentTarget.form).addClass("loading");

        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          data: formdata,
          complete: function (jqXHR, response) {
            if (jqXHR.status == 200) {
              //product added to cart successfully
              CartPopup.update(function () {
                CartPopup.open();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $(e.currentTarget.form).removeClass("loading");
                $.getJSON("/cart.js", function (data) {
                  var count = data.item_count;
                  if ($(".utility-icon.cart-icon .cart-badge").length) {
                    $(".utility-icon.cart-icon .cart-badge").text(count);
                  } else {
                    $(".utility-icon.cart-icon").append(
                      '<span class="cart-badge">' + count + "</span>"
                    );
                  }
                });
              });
            } else {
              //failed to add to cart for x reason
              var resText = jqXHR.responseText;
              if (resText.indexOf("You can't add more") > -1) {
                console.log(
                  "You attempted to add more of this item than we have in stock, please select a lower quantity and try again."
                );
              } else if (resText.indexOf("are in your bag") > -1) {
                console.log(
                  "The remaining inventory of this product option is already in your bag."
                );
              } else {
                console.log(
                  "Something went wrong trying to add to bag " + response
                );
              }
              $("html, body").animate({ scrollTop: 0 }, "slow");
              $(e.currentTarget.form).removeClass("loading");
            }
          },
        });
      }
    });
  })();

  var SB019DM = {
    init: function () {
      //        this.mainCSS();
      this.mainJS();
      this.goals();
    },

    mainJS: function () {
      //For JS
      function insertBefore(el, html) {
        el.insertAdjacentHTML("beforebegin", html);
      }

      let mobileImages = `
                <div style="width: 65px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350652Vogue%403x.png" />
                </div>
                <div style="width: 80px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350449forbes%403x.png" />
                </div>
                <div style="width: 130px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652370669refinery%403xx.png" />
                </div>
                <div style="width: 80px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350501Harper%27s_Bazaar_color_logo+1%403x.png" />
                </div>
                <div style="width: 100px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350618image+9%403x.png" />
                </div>
                <div style="width: 170px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350660who-what-wear-vector-logo+1%403x.png" />
                </div>
                <div style="width: 60px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350315brides-logo-vector+1%403xx.png" />
                </div>
                <div style="width: 100px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350440CBS_News_logo+1%403x.png" />
                </div>
                <div style="width: 30px" class="img_item img_area">
                    <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350634image+10%403x.png" />
                </div>
            `;

      mobileImages =
        mobileImages +
        mobileImages +
        mobileImages +
        mobileImages +
        mobileImages;

      const img_carrousel = `<div class="img_carrousel_wp">
                <div class="desktop_img">
                    <div class="desktop_img_wp container">
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350652Vogue%403x.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350449forbes%403x.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652370669refinery%403xx.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350501Harper%27s_Bazaar_color_logo+1%403x.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350618image+9%403x.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350660who-what-wear-vector-logo+1%403x.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350315brides-logo-vector+1%403xx.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350440CBS_News_logo+1%403x.png" />
                        </div>
                        <div class="img_area">
                            <img src="https://cdn-3.convertexperiments.com/uf/10035801/10033777/1652350634image+10%403x.png" />
                        </div>
                    </div>
                </div>
                <div class="mobile_img">
                    <div class="img_carrousel rips-bar-inner">
                        ${mobileImages}
                    </div>
                </div>
            </div>`;

      insertBefore(
        document.querySelector(".yotpo-reviews-section"),
        img_carrousel
      );

      // this.initSlickSlider();
    },
    // initSlickSlider: function () {
    //     (function pollForjQuery() {
    //         if (window.jQuery !== undefined && window.jQuery().flickity !== undefined) {
    //             // $(".sl_wrapper .single_item").show();

    //             $('.img_carrousel').flickity({
    //                 pageDots: false,
    //                 prevNextButtons: false,
    //                 contain: true,
    //                 autoPlay: true
    //             });

    //         } else {
    //             setTimeout(pollForjQuery, 25);
    //         }
    //     })();
    // },
    goals: function () {
      // For Goal/Metric JS
    },
  };

  $(window).trigger("resize");
  refreshSmooth.init();
});

jQuery(document).ready(function ($) {
  const subMenuGrandchild = document.querySelectorAll(".grandchild_parent");

  subMenuGrandchild.forEach((item) => {
    item.addEventListener("click", () => {
      const isOpened = item.getAttribute("data-active") == "true";
      if (isOpened) {
        item.setAttribute("data-active", "false");
      } else {
        item.setAttribute("data-active", "true");
      }
    });
  });
});

if (window.location.href.indexOf("product") > -1) {
  const interval = setInterval(function () {
    const elements = document.querySelectorAll(".yotpo-radio-label-text");

    if (elements && elements.length) {
      clearInterval(interval);
      elements.forEach((el) => {
        el.innerText = el.innerText.replace(
          "Every month",
          "Month-to-Month Plan"
        );
        el.innerText =
          el.innerText.indexOf("Every 12 months") > -1
            ? "Monthly Price for Annual Plan"
            : el.innerText;
      });
    }
  }, 500);
}

(function () {
  const dataSpeed = $(".gheader-wrapper").attr("data-speed");
  const swiperTopBanner = $(".gheader-wrapper .swiper-wrapper").flickity({
    cellAlign: "center",
    contain: true,
    wrapAround: true,
    autoPlay: Number(dataSpeed),
    pauseAutoPlayOnHover: true,
    pageDots: false,
    friction: 0.8,
    selectedAttraction: 0.15,
    on: {
      ready: function () {
        $(".gheader-wrapper .gheader__banner").removeClass("hide-rest");
      },
      change: function (index) {
        const currentElm = $(".gheader-wrapper .gheader__banner.is-selected");
        const dataColor = currentElm.attr("data-color");
        const arrows = $(".gheader-wrapper .flickity-prev-next-button");
        // change arrows color
        arrows.css("color", dataColor);
      },
    },
  });
  console.log(swiperTopBanner, "swiperTopBanner");
})();


//Breadcrumbs Feature to use the right collection
(() => {
  const KEY = 'lastCollectionForBreadcrumb';
  const MAX_AGE = 6 * 60 * 60 * 1000; // 6 hours

  const path = window.location.pathname;

  const isCollectionPage = path.startsWith('/collections/') && !path.includes('/products/');
  const isProductPage = path.startsWith('/products/');

  // If we're on any other page (home, search, pages, etc.), clear the stored collection
  // to avoid leaking a previously visited collection into unrelated product visits.
  if (!isCollectionPage && !isProductPage) {
    sessionStorage.removeItem(KEY);
    return;
  }

  // Collection page: store {handle, title} so we can reuse it on the next PDP visit.
  // Title is taken from the collection H1 (as requested).
  if (isCollectionPage) {
    const title = document.querySelector('h1')?.textContent?.trim();
    const handle = path.split('/collections/')[1]?.split('/')[0]?.trim(); // used only for matching

    if (title && handle) {
      localStorage.setItem(KEY, JSON.stringify({ handle, title, ts: Date.now() }));
    }
    return;
  }

  // Product page: replace the breadcrumb collection only if the stored collection
  // matches one of the product's collection handles (embedded in Liquid).
  // If it doesn't match, keep the Liquid-rendered default (first product collection).
  if (isProductPage) {
    const container = document.querySelector('[data-prev-collection][data-product-collections]');
    const link = container?.querySelector('a');

    let data;
    try {
      data = JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (_) {
      data = null;
    }

    const isFresh =
      data &&
      data.handle &&
      data.title &&
      (Date.now() - (data.ts || 0)) <= MAX_AGE;

    if (container && link && isFresh) {
      const allowed = (container.getAttribute('data-product-collections') || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

      // Only override if the product actually belongs to that collection
      if (allowed.includes(data.handle)) {
        link.textContent = data.title;
        link.setAttribute('href', `/collections/${data.handle}`);
      }
    }

  }
})();